import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="m17.5 9 3.369-2.551c.143-.111.337-.003.364.187l1.01 7.067c.028.2-.14.35-.299.281L18 12.5"
    />
    <path
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="m14.09 18.188 2.778-.397a1.77 1.77 0 0 0 1.498-2.015l-1.348-9.44a1.767 1.767 0 0 0-2-1.503L3.75 6.443a1.767 1.767 0 0 0-1.5 2.001l1.35 9.455a1.767 1.767 0 0 0 2 1.502l1.484-.212"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
    <path
      fill="currentColor"
      d="m16.778 8.896.084.594 1.188-.17-.085-.593-.593.085zM9.299 5.044a.6.6 0 1 0 .17 1.188l-.085-.594zm5.72-.21.084.593a1.167 1.167 0 0 1 1.321.993l.594-.085.594-.085a2.367 2.367 0 0 0-2.679-2.01zm1.999 1.501-.594.085.354 2.476.594-.084.593-.085-.353-2.477zm-7.634-.697.085.594 5.634-.805-.085-.593-.085-.594-5.634.804z"
    />
  </svg>
);
export const VideoTherapistIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
